const SmartMarketplace = () => {
  return <div>SmartMarketplace</div>;
};

export default SmartMarketplace;
